import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Notification } from '@wix/design-system';

const ReviewUnavailableNotification: FC<{
  show: boolean;
  onClose: () => void;
}> = ({ show, onClose }) => {
  const { t } = useTranslation();

  return (
    <Notification theme="error" show={show} type="sticky">
      <Notification.TextLabel ellipsis={false}>
        {t('marketplace.template-page.review.review-not-available.text')}
      </Notification.TextLabel>
      <Notification.ActionButton onClick={onClose}>
        {t('marketplace.template-page.review.review-not-available.cta')}
      </Notification.ActionButton>
      <Notification.CloseButton onClick={onClose} />
    </Notification>
  );
};

export default ReviewUnavailableNotification;
